import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "complaint-type",
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        enName: "",
        chName: "",
        twName: ""
      },
      dialogVisible: false,
      // 弹窗状态
      scene: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getScene();
          case 1:
            _this.getData();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getScene: function getScene() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getSceneList();
            case 1:
              res = _context2.v;
              _this2.scene = res.data || [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getComplaintTypeList();
            case 1:
              res = _context3.v;
              _this3.tableData = res.data;
              _this3.tableData.forEach(function (item) {
                var _item$scenes;
                item.sceneList = ((_item$scenes = item.scenes) === null || _item$scenes === void 0 ? void 0 : _item$scenes.map(function (item) {
                  var _this3$scene$find;
                  return ((_this3$scene$find = _this3.scene.find(function (scene) {
                    return scene.code == item;
                  })) === null || _this3$scene$find === void 0 ? void 0 : _this3$scene$find.name) || item;
                })) || [];
              });
              _this3.tableLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = _.cloneDeep(row);
      this.dialogVisible = true;
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!_this4.form.id) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return _this4.$api.updateComplaintType(_this4.form);
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.n = 3;
              return _this4.$api.addComplaintType(_this4.form);
            case 3:
              _this4.dialogVisible = false;
              _this4.form = {};
              _this4.getData();
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};